import type { PaymentMethod } from "@pandas/http-client";
import { CountryCode } from "libphonenumber-js";
import { StateCreator } from "zustand";
import { Storage } from "../index";

// INITIAL STATE
export type CustomerInfoSlice = {
	fullName: string | null;
	email: string | null;
	iban: string | null;
	phoneNumber: string | null;
	countryCode: CountryCode | null;
	paymentMethod?: PaymentMethod;
	consent?: boolean;
	setCustomerInfo: (_customerInfo: CustomerInfo) => void;
	resetCustomerInfo: () => void;
};

// ACTION PAYLOAD TYPES
type CustomerInfo = {
	fullName?: string;
	email?: string;
	phoneNumber?: string;
	countryCode?: CountryCode;
	paymentMethod?: PaymentMethod;
	iban?: string;
};

const initialState = {
	fullName: null,
	email: null,
	phoneNumber: null,
	countryCode: null,
	iban: null,
	consent: false,
};

export const createCustomerInfoSlice: StateCreator<Storage, [], [], CustomerInfoSlice> = (set) => ({
	...initialState,
	setCustomerInfo: (customerInfo: CustomerInfo) =>
		set((state) => ({
			...state,
			...customerInfo,
		})),
	resetCustomerInfo: () => set(initialState),
});
